/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { AiOutlineHome, AiOutlineUser, AiOutlineBook } from 'react-icons/ai';
import { RiMessage2Line, RiServiceLine, RiAnchorFill, RiSunFill, RiMoonFill } from 'react-icons/ri';
import { AiOutlineFullscreen, AiOutlineFullscreenExit } from 'react-icons/ai';
import './Nav.css';

const Nav = ({ 
  changeLanguage,
  navAnchor, 
  setNavAnchor,
  fullscreen, 
  themeMode, 
  handleFullscreen,
  handleThemeMode,
  t,
}) => {
  return (
    <nav>
      {/* // Dropdown menu */}
      <div className="anchor">
        <button className="anchorbtn"><RiAnchorFill /></button>
            <div className="anchor-content">
              <a 
                className={ navAnchor === '#root' ? 'navAnchor' : ''}  
                onClick={ () => setNavAnchor('#root') } 
                href="#home"
                aria-label='Home'
              >
                  <AiOutlineHome />
              </a>
              <a 
                className={ navAnchor === '#about' ? 'navAnchor' : ''} 
                onClick={ () => setNavAnchor('#about') } 
                href="#about"
                aria-label='About'
              >
                  <AiOutlineUser />
              </a>
              <a 
                className={ navAnchor === '#experience' ? 'navAnchor' : ''} 
                onClick={ () => setNavAnchor('#experience') } 
                href="#experience"
                aria-label='Experience'
              >
                  <AiOutlineBook />
              </a>
              <a 
                className={ navAnchor === '#services' ? 'navAnchor' : ''} 
                onClick={ () => setNavAnchor('#services') } 
                href="#services"
                aria-label='Services'
              >
                  <RiServiceLine />
              </a>
              <a 
                className={ navAnchor === '#contact' ? 'navAnchor' : ''} 
                onClick={ () => setNavAnchor('#contact') } 
                href="#contact"
                aria-label='Contact'
              >
                  <RiMessage2Line />
              </a>
        </div>
      </div>

      {/* Fullscreen */}
      <a 
        style={{ transform: fullscreen ? 'rotate(360deg)' : '', transition: 'all 400ms ease-in-out' }}
        onClick={ handleFullscreen } 
        >
          { fullscreen ? <AiOutlineFullscreenExit /> : <AiOutlineFullscreen /> }
      </a>

      {/* Dark/Light Mode */}
      <a 
        style={{ transform: themeMode ? 'rotate(360deg)' : '', transition: 'all 400ms ease-in-out' }}
        onClick={ () => handleThemeMode()} 
        >
         { themeMode ? <RiMoonFill /> : <RiSunFill /> }
      </a>
      
     {/* Dropdown Languages */}
     <div className="lang">
        <button className="langbtn">{t("root-navbar-btn")}</button>
            <div className="lang-content">
              <a 
                onClick={ () => changeLanguage('pt') }
                aria-label='Translate to Portuguese'
              >
                  🇧🇷&emsp;Portuguese
              </a>
              <a 
                onClick={ () => changeLanguage('es') } 
                aria-label='Translate to Spanish'
              >
                  🇪🇸&emsp;Spanish
              </a>
              <a 
                onClick={ () => changeLanguage('en') }
                aria-label='Translate to English'
              >
                  🇺🇸&emsp;English
              </a>
        </div>
      </div>
    </nav>
  )
}

export default Nav;
